import { StyleSheet } from "react-native";
import { Surface } from "react-native-paper";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import type { IconType } from "../../icon";
import Box from "../Box";
import Button from "../Button";
import Container from "../Container";

type Props = {
	label: string;
	onPress: () => void;
	iconName?: IconType;
	secondaryAction?: {
		label: string;
		onPress: () => void;
		iconName?: IconType;
	};
	maxWidth?: "xxs" | "xs" | "sm" | "md" | "lg";
	paddingTop?: number;
	paddingBottom?: number;
};

export const ScreenBottomActionBar = ({
	label,
	onPress,
	iconName,
	secondaryAction,
	maxWidth = "sm",
	paddingTop = 16,
	paddingBottom = 12,
}: Props) => {
	const insets = useSafeAreaInsets();

	return (
		<Surface
			style={{
				paddingBottom: Math.max(insets.bottom, paddingBottom),
				paddingTop,
			}}
		>
			<Container maxWidth={maxWidth} padding autoSize>
				{secondaryAction ? (
					<Box flexDirection="row" gap={8}>
						<Button
							mode="contained"
							icon={iconName}
							onPress={onPress}
							style={{ flex: 1 }}
							contentStyle={styles.buttonContent}
						>
							{label}
						</Button>
						<Button
							mode="outlined"
							icon={secondaryAction.iconName}
							onPress={secondaryAction.onPress}
							style={{ flex: 1 }}
							contentStyle={styles.buttonContent}
						>
							{secondaryAction.label}
						</Button>
					</Box>
				) : (
					<Button
						mode="contained"
						icon={iconName}
						onPress={onPress}
						contentStyle={styles.buttonContent}
					>
						{label}
					</Button>
				)}
			</Container>
		</Surface>
	);
};

const styles = StyleSheet.create({
	buttonContent: {
		height: 48,
	},
});
